import { Outlet, Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function Layout() {
  const { user, signOut } = useAuth()

  const handleLogout = async () => {
    await signOut()
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl">🦊</span>
            <span className="text-xl font-bold text-gray-900">KitScope</span>
          </Link>
          <nav className="flex items-center gap-4">
            <Link
              to="/import"
              className="text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              Import
            </Link>
            
            {/* User menu */}
            <div className="flex items-center gap-3">
              {user?.email && (
                <span className="text-xs text-gray-500 hidden sm:inline">
                  {user.email}
                </span>
              )}
              <button
                onClick={handleLogout}
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-600 hover:text-gray-800"
                title="Sign out"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 pb-20 overflow-auto">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="max-w-2xl mx-auto px-4 py-2 flex items-center justify-center">
          <p className="text-xs text-gray-400">KitScope v0.1.0</p>
        </div>
      </footer>
    </div>
  )
}

export default Layout
